export default {
  "buttons": {
    "readMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Leggi l'articolo"])},
    "loadMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mostra altri articoli"])}
  },
  "pagination": {
    "of": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["di"])},
    "loaded": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["articoli caricati"])}
  }
}